<template>
    <div class="min-h-screen flex items-center justify-center p-6 ct-bg-1--alt">
        <div class="w-full max-w-sm space-y-8 text-center">
            <EasyToolsIcon class="h-8 mx-auto" />
            <p class="ct-text-1 text-3xl font-semibold">{{ $t("shared.access.title") }}</p>
            <div
                class="w-full space-y-4 ct-bg-2 rounded-lg p-6 ct-text-2 text-base text-left leading-normal"
            >
                <p>{{ $t("shared.access.info") }}</p>
                <p>{{ $t("shared.access.options") }}</p>
                <ul class="pl-3 list-disc list-inside space-y-1">
                    <li>
                        <a href="https://www.easy.tools/" class="underline">{{
                            $t("shared.access.homepage")
                        }}</a>
                    </li>
                    <li>
                        <a href="https://www.easy.tools/docss" class="underline">{{
                            $t("shared.access.documentation")
                        }}</a>
                    </li>
                    <li>
                        <a href="https://community.easy.tools/home" class="underline">{{
                            $t("shared.access.community")
                        }}</a>
                    </li>
                </ul>
                <p>
                    {{ $t("shared.access.you_can_always") }}
                    <a href="mailto:hello@easy.tools">{{ $t("shared.access.contact_us") }}</a>
                    {{ $t("shared.access.if_you_need_help") }}
                </p>
            </div>
            <a class="block w-full" href="https://www.easy.tools/">
                <ButtonPrimaryLg class="w-full">
                    {{ $t("shared.access.back_to_homepage") }}
                </ButtonPrimaryLg>
            </a>
        </div>
    </div>
</template>

<script>
import { EasyToolsIcon } from "@easy/ui/icons";
import { ButtonPrimaryLg } from "@easy/ui/buttons";
import { previewLanguageService } from "@/shared/user/preview-language.service";

export default {
    name: "NotFoundPage",
    components: {
        EasyToolsIcon,
        ButtonPrimaryLg,
    },
    created() {
        previewLanguageService.setLanguage(previewLanguageService.fallbackLanguage);
    },
};
</script>
